module.exports = __webpack_public_path__ + "img/gfi.c7ba0d00.png";